<template>
<div class="text-center">
  <div class="space-20"></div>
  <img :src="imageUrl('locashop-loading.gif')" alt="" class="Loca.Shop">
  <div class="space-20"></div>
  </div>
</template>

<script>
  import * as config from '../../config'

  export default{
    name: 'Loading',
    computed: {
      apiDomain () {
        return config.apiDomain
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Loading.vue?ad456762